// This file was generated by lezer-generator. You probably shouldn't edit it.
import { Parser } from "lezer";
export var parser = Parser.deserialize({
  states: "$OOSOPOOQZOPOOObOPO'#CiOROP'#Ci'#CiOSOPO,58{OSOPO,58{OuOPO'#CcOROP,58|,58|OROP1G.g1G.gO!SOPO1G.gO!dOPO'#CmOSOPO'#CmO!qOPO,58}O!uOPO'#CeO!|OPO(3@vOROP,59X,59XO!dOPO,59XOROP1G.i1G.iOROP,59O,59OO#^OPO-E6bOSOPO,59OOROP1G.s1G.sO#kOPO3)+|",
  stateData: "#x[OS~RQOSRO~^SO_TO~`UOY]X^]X_]Xc]Xd]X~RQOSRObZOdaP~^SOYTi_TicTidTi~^SO_TOc^OdXP~daO~c^OdXX~RQOSRObdOcWZdWZ~^SO_TOcWcdWc~^SO_TOcWkdWk~",
  goto: "!fbPPPPPcclovPPP|PPP!c_ROSTUZ^dRVQS]Y`Rb]Q_YRe`QPOQWSQXTQYUQ`ZQc^RfdR[U",
  nodeNames: "⚠  ⚠ Name Number BinaryExpression FunctionCall ArgList",
  repeatNodeCount: 1,
  tokenData: "$b~RcX^!^pq!^xy#Ryz#Wz{#]{|#b|}#g!O!P#l!Q![#}!c!}$V#T#o$V#y#z!^$f$g!^#BY#BZ!^$IS$I_!^$I|$JO!^$JT$JU!^$KV$KW!^&FU&FV!^~!cY[~X^!^pq!^#y#z!^$f$g!^#BY#BZ!^$IS$I_!^$I|$JO!^$JT$JU!^$KV$KW!^&FU&FV!^~#WO`~~#]Od~~#bO^~~#gO_~~#lOc~~#oP!O!P#r~#uP!O!P#x~#}Ob~~$SPS~!Q![#}~$[QR~!c!}$V#T#o$V",
  tokenizers: [0],
  specializeTable: 3,
  tokenPrec: 3
});